import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";
import StyleGuidePage from "./components/StyleGuidePage";
import LoginPage from "./components/LoginPage";
import BookingSummaryPage from "./components/BookingSummaryPage";
import GuestListingPage from "./components/GuestListingPage";
import DietaryPreferenceAndSpecialRequestPage from "./components/DietaryPreferenceAndSpecialRequestPage";
import DivingPage from "./components/DivingPage";
import WetsuitPage from "./components/WetsuitPage";
import PrePostArrangementPage from "./components/PrePostArrangementPage";
import ConfirmationPage from "./components/ConfirmationPage";
import CruiseTicketPage from "./components/CruiseTicketPage";
import CheckinSuspended from "./components/CheckinSuspended";

Vue.use(VueRouter);

// 1. Define route components.
// These can be imported from other files
// =====
// We imported the components on top.

// 2. Define some routes
// Each route should map to a component.
const routes = [
  {
    path: "/style-guide",
    name: "style-guide",
    component: StyleGuidePage,
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    alias: "/",
    meta: { hideFooter: true },
  },
  {
    path: "/checkin-suspended",
    name: "checkin-suspended",
    component: CheckinSuspended,
  },
  {
    path: "/step-1",
    name: "step-1",
    component: BookingSummaryPage,
  },
  {
    path: "/step-2",
    name: "step-2",
    component: GuestListingPage,
    props: (route) => ({ index: route.query.index }),
  },
  {
    path: "/step-3",
    name: "step-3",
    component: DietaryPreferenceAndSpecialRequestPage,
    props: (route) => ({ index: route.query.index }),
  },
  {
    path: "/step-3b",
    name: "step-3b",
    component: DivingPage,
    props: (route) => ({ index: route.query.index }),
  },
  {
    path: "/step-3c",
    name: "step-3c",
    component: WetsuitPage,
    props: (route) => ({ index: route.query.index }),
  },
  {
    path: "/step-4",
    name: "step-4",
    component: PrePostArrangementPage,
    props: (route) => ({ index: route.query.index }),
  },
  {
    path: "/step-5",
    name: "step-5",
    component: ConfirmationPage,
  },
  {
    path: "/completed",
    name: "completed",
    component: CruiseTicketPage,
  },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for `routes: routes`
  scrollBehavior(to, from, savedPosition) {
    // Returning the savedPosition will result in a native-like behavior when navigating with back/forward buttons:
    return savedPosition || { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.name === "login" || to.name === "completed") {
    // Remove navigation prompt
    window.onbeforeunload = null;
  } else {
    // Enable navigation prompt
    window.onbeforeunload = function () {
      return true;
    };
  }

  if (to.name === "login") {
    return next();
  }

  // Redirects user to login page if booking in the store is empty (ie. user is not logged in).
  if (
    !(
      store &&
      store.state &&
      store.state.booking &&
      store.state.booking.booking
    )
  ) {
    return next("/");
  }

  // Redirects user to completed page if user has completed the checked-in before (only applicable for non-test booking)
  if (
    to.name !== "completed" &&
    store.state.booking.booking.bookingCheckedIn &&
    !store.state.booking.booking.isTestBooking
  ) {
    return next("/completed");
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js